<template>
    <UApp :locale="uiLocale">
        <component :is="layout" />
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import * as locales from '@nuxt/ui/locale'

    import Default from '@/layouts/Default.vue'
    import Blank   from '@/layouts/Blank.vue'
    import Page    from '@/layouts/Page.vue'

    const route = useRoute()
    const { locale } = useI18n()

    const uiLocale = computed(() => (locales as Record<string, any>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank, Page }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
